export const results = [
  {
    count: 0,
    title: `Есть простор для развития!`,
    text: ``
  },
  {
    count: 2,
    title: 'У&nbsp;вас неплохая база, но&nbsp;есть простор для развития!',
    text: ``
  },
  {
    count: 4,
    title: 'Очень хорошо!',
    text: `Вы&nbsp;уверенно чувствуете себя в&nbsp;теме технологий связи, но&nbsp;есть точки для развития.`
  },
  {
    count: 6,
    title: 'Вы&nbsp;&mdash; гуру технологий связи!',
    text: `Легко различаете виды и&nbsp;поколения беспроводной связи и&nbsp;понимаете место технологий в&nbsp;бизнесе.`
  }
]

export function calc (score) {
  return results.find(({ count }) => (score <= count))
}

export default [
  {
    text: `
      Начнем! У&nbsp;вас офис на&nbsp;500 человек в&nbsp;старом здании в&nbsp;центре города. Сотовая связь работает только возле окон, а&nbsp;подключенный несколько лет назад Wi&#8209;Fi уже не&nbsp;справляется с&nbsp;нагрузкой. Что делать?
    `,
    correct: 1,
    options: [
      {
        text: `Скоро везде подключат публичный&nbsp;5G, и&nbsp;проблема решится сама собой.`,
        explain: `
          <p>
            С&nbsp;новым стандартом связи связывают большие надежды, но&nbsp;для него пока есть ряд ограничений. 
            Активное внедрение&nbsp;5G, по&nbsp;<a href="https://www.rbc.ru/technology_and_media/20/01/2021/6006d49b9a794726acf2482c" target="_blank" class="link link--underline link--cyan">прогнозу</a> 
            АКРА, начнется в&nbsp;России не&nbsp;раньше 2024&nbsp;года. Вы&nbsp;не&nbsp;можете себе позволить ждать так долго, к&nbsp;тому&nbsp;же стены вашего офисного здания могут стать преградой и&nbsp;для 5G. Для закрытых пространств с&nbsp;большим скоплением людей вам подойдет Wi&#8209;Fi&nbsp;6. 
          </p>
          <br> 
          <p>
            По&nbsp;результатам 
            <a href="https://www.cnews.ru/articles/2020-12-11_wifi_6_bystree_vyshe_silnee" target="_blank" class="link link--underline link--cyan">исследования</a> 
            <a href="https://jet.su" class="link link--underline link--cyan">&laquo;Инфосистемы Джет&raquo;</a>, 
            новый стандарт повышает емкость сетей, обеспечивает практическую скорость до&nbsp;8&nbsp;Гб/с на&nbsp;точку доступа и&nbsp;снижает задержки в&nbsp;три раза&nbsp;&mdash; до&nbsp;10&nbsp;мс, это позволяет передавать видео высокого качества, работать с&nbsp;VR- и&nbsp;AR-приложениями, проводить беспроводные видеоконференции в&nbsp;формате&nbsp;4K.          
          </p>
        `,
      },
      {
        text: `Подумаем над подключением Wi&#8209;Fi нового поколения, для закрытого помещения это подходит лучше и&nbsp;обойдется дешевле.`,
        explain: `
          <p>
            Очень здравое решение! Стены зданий — серьезная преграда для сигнала сотовой связи даже последних поколений. Отличный вариант беспроводной связи для закрытых пространств — Wi&#8209;Fi&nbsp;6.
          </p>
          <br>
          <p>
            По&nbsp;результатам 
            <a href="https://www.cnews.ru/articles/2020-12-11_wifi_6_bystree_vyshe_silnee" target="_blank" class="link link--underline link--cyan">исследования</a> 
            <a href="https://jet.su" class="link link--underline link--cyan">&laquo;Инфосистемы Джет&raquo;</a>, 
            новый стандарт повышает емкость сетей, обеспечивает практическую скорость до&nbsp;8&nbsp;Гб/с на&nbsp;точку доступа и&nbsp;снижает задержки в&nbsp;три раза&nbsp;&mdash; до&nbsp;10&nbsp;мс, это позволяет передавать видео высокого качества, работать с&nbsp;VR- и&nbsp;AR-приложениями, проводить беспроводные видеоконференции в&nbsp;формате&nbsp;4K.
          </p>
        `,
      },
      {
        text: `Говорят, вместо 5G&nbsp;все стали запускать частные LTE-сети. Кажется, это наш вариант.`,
        explain: `
          <p>
            Из-за трудностей с&nbsp;внедрением 5G&nbsp;переходным этапом к&nbsp;новому стандарту считаются частные LTE-сети. Однако для офиса на&nbsp;100 человек это решение может оказаться чересчур затратным. Присмотритесь к&nbsp;Wi&#8209;Fi&nbsp;6, это отличный вариант для закрытых пространств с&nbsp;большим скоплением людей.
          </p>
          <br>
          <p>
            По&nbsp;результатам
            <a href="https://www.cnews.ru/articles/2020-12-11_wifi_6_bystree_vyshe_silnee" target="_blank" class="link link--underline link--cyan">исследования</a>
            <a href="https://jet.su" class="link link--underline link--cyan">&laquo;Инфосистемы Джет&raquo;</a>, 
            новый стандарт повышает емкость сетей, обеспечивает практическую скорость до&nbsp;8&nbsp;Гб/с на&nbsp;точку доступа и&nbsp;снижает задержки в&nbsp;три раза&nbsp;&mdash; до&nbsp;10&nbsp;мс, это позволяет передавать видео высокого качества, работать с&nbsp;VR- и&nbsp;AR-приложениями, проводить беспроводные видеоконференции в&nbsp;формате&nbsp;4K.
          </p>
        `,
      }
    ],
  },
  {
    text: `Вы&nbsp;управляете торговым центром. Ваши посетители хотят быстрее находить необходимые товары и&nbsp;услуги, а&nbsp;магазины&nbsp;&mdash; обновлять политику продвижения в&nbsp;режиме реального времени. Что вы&nbsp;должны сделать?`,
    correct: 1,
    options: [
      {
        text: `Назначить специального сотрудника, который будет направлять покупателя и&nbsp;вручную изменять цену на&nbsp;товар.`,
        explain: `
        <p>
          Вам понадобится целая армия сотрудников, чтобы успевать направлять каждого, это дорого и&nbsp;неэффективно. Гораздо лучше справится технология интернета вещей. С&nbsp;помощью Wi&#8209;Fi-IoT можно обеспечить навигацию и&nbsp;обновление цен в&nbsp;режиме реального времени.
        </p>
        <br>
        <p>
          Компании Huawei и&nbsp;Navigine совместно разработали систему, использующую встроенный Bluetooth на&nbsp;точках доступа Wi&#8209;Fi&nbsp;6 серии AirEngine. Эта система обеспечивает точность позиционирования и&nbsp;навигации до&nbsp;3&nbsp;м. К&nbsp;тому&nbsp;же точки доступа AirEngine могут работать как шлюзы IoT, это позволит обновлять цены в&nbsp;режиме реального времени с&nbsp;помощью электронных ценников, сокращая затраты на&nbsp;персонал и&nbsp;снижая вероятность ошибок. Конвергенция сетей электронных ценников и&nbsp;сетей Wi&#8209;Fi уже широко используется в&nbsp;мире.
        </p>
        `,
      },
      {
        text: `Настроить автоматическую навигацию по&nbsp;магазинам с&nbsp;помощью технологии Wi&#8209;Fi-IoT и&nbsp;использовать электронные ценники для обновления информации о&nbsp;стоимости товаров в&nbsp;режиме реального времени.`,
        explain: `
          <p>
            Отличное решение! Сети интернета вещей отлично справятся и&nbsp;с&nbsp;навигацией, и&nbsp;с&nbsp;обновлением цен. Компании Huawei и&nbsp;Navigine совместно разработали систему, использующую встроенный Bluetooth на&nbsp;точках доступа Wi&#8209;Fi&nbsp;6 серии AirEngine. Эта система обеспечивает точность позиционирования и&nbsp;навигации до&nbsp;3&nbsp;м. К&nbsp;тому&nbsp;же точки доступа AirEngine могут работать как шлюзы IoT, это позволит обновлять цены в&nbsp;режиме реального времени с&nbsp;помощью электронных ценников, сокращая затраты на&nbsp;персонал и&nbsp;снижая вероятность ошибок. Конвергенция сетей электронных ценников и&nbsp;сетей Wi&#8209;Fi уже широко используется в&nbsp;мире.
          </p>
        `,
      },
      {
        text: `Установить больше указателей, чтобы клиенты могли по&nbsp;ним ориентироваться в&nbsp;торговом центре.`,
        explain: `
          <p>
            В&nbsp;современных торговых центрах все постоянно меняется, и&nbsp;вам нужна гибкость, а&nbsp;указатели будут только путать посетителей. Гораздо лучше с&nbsp;внутренним позиционированием и&nbsp;навигацией справится технология Wi&#8209;Fi-IoT. Компании Huawei и&nbsp;Navigine совместно разработали систему, использующую встроенный Bluetooth на&nbsp;точках доступа серии AirEngine, она обеспечивает точность позиционирования и&nbsp;навигации до&nbsp;3&nbsp;м.
          </p>
          <br>
          <p>
            Точки доступа AirEngine могут работать как шлюзы IoT, это позволит обновлять цены в&nbsp;режиме реального времени с&nbsp;помощью электронных ценников, сокращая затраты на&nbsp;персонал и&nbsp;снижая вероятность ошибок. Конвергенция сетей электронных ценников и&nbsp;сетей Wi&#8209;Fi уже широко используется в&nbsp;мире.
          </p>
        `,
      }
    ],
  },
  {
    text: "Вы&nbsp;работаете в&nbsp;производственной компании, которая планирует внедрить технологию интернета вещей на&nbsp;сборочной линии. Обычно перспективы этой технологии связывают с&nbsp;5G, но&nbsp;у&nbsp;этого стандарта есть серьезные ограничения. Какие?",
    correct: 1,
    options: [
      {
        text: `Новому стандарту сотовой связи не&nbsp;страшны преграды, но&nbsp;скорость передачи данных не&nbsp;сильно выше, чем в&nbsp;сетях LTE.`,
        explain: `
          <p>
            Не&nbsp;совсем. В&nbsp;теории стандарт 5G&nbsp;может обеспечить очень высокие скорости, в&nbsp;десятки раз превышающие максимальную скорость стандарта&nbsp;4G (LTE). Однако достигаться такие скорости смогут только в&nbsp;условиях прямой видимости между передающей станцией и&nbsp;принимающим устройством. Для этого операторам придется устанавливать много ретрансляторов, а&nbsp;это очень дорого.
          </p>
        `
        ,
      },
      {
        text: `Один из&nbsp;ключевых минусов 5G&nbsp;в&nbsp;том, что на&nbsp;передачу сигнала могут влиять любые преграды, даже капли дождя или проходящий мимо человек.`,
        explain: `
          <p>
            Совершенно верно! Особенность диапазонов 5G&nbsp;в&nbsp;том, что связь будет зависеть от&nbsp;преград на&nbsp;пути сигнала даже больше, чем LTE. Реализовать IoT-решения уже сейчас можно с&nbsp;Wi&#8209;Fi&nbsp;6: максимальная расчетная скорость для этой технологии (более 10,75&nbsp;Гбит/с) сопоставима со&nbsp;скоростями&nbsp;5G, задержка также составляет всего 10&nbsp;мс. Решение от&nbsp;Huawei включает встроенный чип и&nbsp;слот для модуля IoT.
          </p>
        `,
      },
      {
        text: `5G&nbsp;всем хорош, но&nbsp;обеспечивает слишком большие задержки в&nbsp;передаче данных.`,
        explain: `
          <p>
            С&nbsp;точностью до&nbsp;наоборот. В&nbsp;теории одно из&nbsp;главных преимуществ 5G&nbsp;как раз в&nbsp;низких задержках, которые позволяют развивать IoT. При этом такие&nbsp;же низкие задержки сегодня уже обеспечивает стандарт Wi&#8209;Fi&nbsp;6, который по&nbsp;стоимости реализации серьезно выигрывает у&nbsp;5G. Низкие задержки позволяют не&nbsp;только развивать IoT, но&nbsp;и&nbsp;передавать видео высокого качества, работать с&nbsp;VR- и&nbsp;AR-приложениями, проводить беспроводные видеоконференции в&nbsp;4K.
          </p>
        `,
      }
    ],
  },
  {
    text: `Вы&nbsp;занимаетесь развитием умных технологий в&nbsp;городе. На&nbsp;дорогах скоро появятся беспилотники, которые смогут обмениваться данными с&nbsp;&laquo;умной&raquo; городской инфраструктурой, например со&nbsp;светофорами и&nbsp;парковками, &laquo;умными&raquo; зданиями. У&nbsp;вас есть время подготовиться к&nbsp;новому тренду. Какая технология связи вам нужна?`,
    correct: 2,
    options: [
      {
        text: "Конечно, 5G.",
        explain: `<p>Этот стандарт связи обеспечивает передачу данных на&nbsp;большие расстояния и&nbsp;лучше подходит для открытых пространств в&nbsp;отличие от&nbsp;Wi&#8209;Fi&nbsp;6, который идеально подходит для закрытых помещений. Для развития &laquo;умного&raquo; города пригодятся обе технологии: например, для &laquo;умной&raquo; парковки или &laquo;умного&raquo; университетского кампуса подойдет Wi&#8209;Fi&nbsp;6, а&nbsp;&laquo;умные&raquo; дороги лучше реализовать с&nbsp;помощью&nbsp;5G.</p>`,
      },
      {
        text: "Не обойтись без Wi&#8209;Fi&nbsp;6.",
        explain: `<p>Этот стандарт связи не&nbsp;уступает 5G&nbsp;в&nbsp;скорости и&nbsp;обеспечивает минимальные задержки, но&nbsp;он&nbsp;лучше подходит для ограниченных пространств: офисных и&nbsp;торговых центров, образовательных учреждений, стадионов, вокзалов, аэропортов и&nbsp;так далее. Безусловно это пригодится для реализации &laquo;умного&raquo; города, но&nbsp;также не&nbsp;обойтись без&nbsp;5G.</p>`,
      },
      {
        text: "Нужны обе, они будут дополнять друг друга.",
        explain: `<p>Совершенно верно, вам понадобятся обе технологии. Если 5G&nbsp;лучше подходит для открытых пространств, то&nbsp;Wi&#8209;Fi&nbsp;6&nbsp;&mdash; прекрасное решение для ограниченных пространств: офисных и&nbsp;торговых центров, образовательных учреждений, стадионов, вокзалов, аэропортов и&nbsp;т.&nbsp;д. В&nbsp;реализации концепции &laquo;умного&raquo; города они будут друг друга дополнять.</p>`,
      }
    ],
  },
  {
    text: "Вы&nbsp;занимаетесь реконструкцией футбольного стадиона. Одно из&nbsp;требований&nbsp;&mdash; хорошая устойчивая связь даже во&nbsp;время центральных матчей, когда стадион забит под завязку. Что нужно учесть в&nbsp;первую очередь при выборе решения?",
    correct: 2,
    options: [
      {
        text: "Высокую плотность устройств на&nbsp;ограниченном пространстве.",
        explain: `
          <p>
            Безусловно, это очень важно: на&nbsp;стадионе могут одновременно находиться десятки тысяч человек, которые захотят поделиться своими фотографиями и&nbsp;видео. Но&nbsp;не&nbsp;стоит пренебрегать безопасностью: вы&nbsp;рискуете потерять контроль над всеми информационными системами.
          </p>
          <br>
          <p>
            На&nbsp;крупнейшем стадионе Швейцарии высокую скорость и&nbsp;безопасность сети удалось обеспечить с&nbsp;помощью решения на&nbsp;основе Wi&#8209;Fi&nbsp;6&nbsp;от&nbsp;Huawei. Обслуживать такую сеть проще благодаря функции удаленного облачного управления. В&nbsp;России эти решения доступны у&nbsp;ключевого интегратора&nbsp;&mdash; компании 
            <a href="https://jet.su" class="link link--underline link--cyan">&laquo;Инфосистемы Джет&raquo;</a>.
          </p>
        `,
      },
      {
        text: "Кибербезопасность. Стадион&nbsp;&mdash; это потенциальная цель для кибератак во&nbsp;время крупных матчей или концертов.",
        explain: `
          <p>
            Безусловно, не&nbsp;стоит пренебрегать кибербезопасностью, но&nbsp;забывать о&nbsp;качестве покрытия тоже нельзя: на&nbsp;стадионе могут одновременно находиться десятки тысяч человек, которые захотят поделиться своими фотографиями и&nbsp;видео. В&nbsp;России эти решения доступны у&nbsp;ключевого интегратора&nbsp;&mdash; компании 
            <a href="https://jet.su" class="link link--underline link--cyan">&laquo;Инфосистемы Джет&raquo;</a>.
          </p>
          <br>
          <p>
            На&nbsp;крупнейшем стадионе Швейцарии высокую скорость и&nbsp;безопасность сети удалось обеспечить с&nbsp;помощью решения на&nbsp;основе Wi&#8209;Fi&nbsp;6&nbsp;от&nbsp;Huawei. Обслуживать такую сеть проще благодаря функции удаленного облачного управления.
          </p>
        `,
      },
      {
        text: "Оба фактора очень важны, нельзя ставить один выше другого.",
        explain: `
          <p>
            Мудрое решение. На&nbsp;крупнейшем стадионе Швейцарии высокую скорость и&nbsp;безопасность сети удалось обеспечить с&nbsp;помощью решения на&nbsp;основе Wi&#8209;Fi&nbsp;6&nbsp;от&nbsp;Huawei. Обслуживать такую сеть проще благодаря функции удаленного облачного управления. В&nbsp;России эти решения доступны у&nbsp;ключевого интегратора&nbsp;&mdash; компании 
            <a href="https://jet.su" class="link link--underline link--cyan">&laquo;Инфосистемы Джет&raquo;</a>.
          </p>
        `,
      }
    ],
  },
  {
    text: "Вы&nbsp;управляете растущим медицинским центром, который активно внедряет IoT-решения на&nbsp;базе Wi&#8209;Fi&nbsp;6. В&nbsp;список решений затесалось одно лишнее, сможете его найти?",
    correct: 2,
    options: [
      {
        text: "Приложения для поиска пути в&nbsp;нужный кабинет.",
        explain: `
          <p>
            Нет, это вполне реальное решение на&nbsp;базе Wi&#8209;Fi&nbsp;6: 30% посетителей опаздывают на&nbsp;прием и&nbsp;с&nbsp;трудом находят нужный кабинет. Еще есть решения для контроля за&nbsp;перемещениями людей и&nbsp;оборудования, а&nbsp;также для контроля за&nbsp;влажностью и&nbsp;температурой. А&nbsp;вот в&nbsp;первичной диагностике IoT пока не&nbsp;используют.
          </p>
        `,
      },
      {
        text: "Контроль перемещений персонала, пациентов и&nbsp;оборудования в&nbsp;реальном времени.",
        explain: `
          <p>
            Нет, это вполне реальное решение на&nbsp;базе Wi&#8209;Fi&nbsp;6: с&nbsp;помощью него можно анализировать поток пациентов и&nbsp;поддерживать связь со&nbsp;всеми сотрудниками. Еще есть решения для поиска пути в&nbsp;нужный кабинет и&nbsp;для контроля за&nbsp;влажностью и&nbsp;температурой. А&nbsp;вот в&nbsp;первичной диагностике IoT пока не&nbsp;используют.
          </p>
        `,
      },
      {
        text: "Автоматическая первичная диагностика пациентов.",
        explain: `
          <p>
            Совершенно верно: в&nbsp;первичной диагностике IoT пока не&nbsp;используют, а&nbsp;остальные решения уже доступны на&nbsp;базе Wi&#8209;Fi&nbsp;6. Новый стандарт позволяет разворачивать сети IoT на&nbsp;единой сетевой инфраструктуре. Интеграция с&nbsp;IoT особенно важна сегодня, потому что все больше предметов получают IP-адреса для удаленного взаимодействия через сеть.
          </p>
        `,
      },
      {
        text: "Контроль за&nbsp;влажностью и&nbsp;температурой воздуха в&nbsp;помещениях.",
        explain: `
          <p>
            Нет, это вполне реальное решение на&nbsp;базе Wi&#8209;Fi&nbsp;6: приборы отслеживают параметры для безопасного хранения препаратов и&nbsp;лабораторных образцов, а&nbsp;в&nbsp;случае отклонений оповещают сотрудников. Еще есть решения для контроля за&nbsp;перемещениями людей и&nbsp;оборудования, а&nbsp;также для поиска пути в&nbsp;нужный кабинет. А&nbsp;вот в&nbsp;первичной диагностике IoT пока не&nbsp;используют.
          </p>
        `,
      }
    ],
  }
]
